import styled, { keyframes } from "styled-components";

const slideUpFade = keyframes`
  from {
    opacity: 0;
    transform: translateY(12px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    cursor: pointer;
    color: #8c8c8c;

    &:hover {
      color: #000;
    }
  }
`;

export const PopoverContent = styled.div`
  width: 360px;
  max-height: 420px;
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 1100;

  background: #ffffff;
  border-radius: 8px;
  padding: 16px;

  box-shadow:
    0 6px 16px rgba(0, 0, 0, 0.08),
    0 3px 6px rgba(0, 0, 0, 0.12);

  display: flex;
  flex-direction: column;
  overflow-y: auto;

  animation: ${slideUpFade} 0.25s ease-out;
  will-change: opacity, transform;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 8px;
  margin-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;

  svg {
    cursor: pointer;
    color: #8c8c8c;

    &:hover {
      color: #000;
    }
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 12px;
`;

export const Container = styled.div<{ $read: boolean }>`
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  padding: 12px;
  background: ${({ $read }) => ($read ? "#ffffff" : "#f9fafb")};
`;

export const ActionLink = styled.a`
  display: inline-block;
  margin-top: 8px;
  color: #1677ff;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const Date = styled.div`
  font-size: 12px;
  color: #8c8c8c;
  align-self: flex-end;
`;
